module.exports = __webpack_public_path__ + "static/media/news3.3e5a0ece.png";